// extracted by css-extract-rspack-plugin
export default {"tabs":"qB3pK","tabsList":"WSAi3","tab":"UhnVd"};